/**
 * Row action definitions for list-style tables (ListViewLayout, SearchViewRecordsTable, ResizableTable).
 * Matches ListViewLayout getRowActions: View, Edit, Clone, Delete with object-specific exclusions.
 */
export function getListViewStyleRowActions(objectName) {
  const actions = [
    { label: 'View', icon: 'fas fa-eye', action: 'view' },
    { label: 'Edit', icon: 'fas fa-edit', action: 'edit' },
    { label: 'Clone', icon: 'fas fa-clone', action: 'clone' },
    { label: 'Delete', icon: 'fas fa-trash', action: 'delete' }
  ];

  if (objectName?.toLowerCase() === 'email_log') {
    return actions.filter((action) => action.action !== 'edit');
  }
  if (objectName?.toLowerCase() === 'user') {
    return actions.filter((action) => action.action !== 'delete');
  }

  return actions;
}
